import {useDispatch, useSelector} from 'react-redux';

import {AlertPageRequest} from 'src/openapi/admin/models/AlertPageRequest';

import {UserPageState, resetScopeCriteria, setScopeCriteria} from '../slices/alertsSlice';


export function useAlertCriteria(scopeKey: string) {
    const dispatch = useDispatch();
    const criteria = useSelector(
        (state: UserPageState) => state.userPage.tabs.content.alerts.criteriaByScope[scopeKey],
    );

    const setCriteria = (patch: Partial<AlertPageRequest>) => {
        dispatch(setScopeCriteria({scopeKey, patch}));
    };

    const reset = () => {
        dispatch(resetScopeCriteria(scopeKey));
    };

    const setPage = (page: number) => {
        setCriteria({pagination: {...criteria.pagination, currentPage: page}});
    };

    const setPageSize = (size: number) => {
        setCriteria({pagination: {...criteria.pagination, currentPage: 1, pageSize: size}});
    };

    const setSort = (
        alertSortField: AlertPageRequest['alertSortField'],
        sortDirection: AlertPageRequest['sortDirection'],
    ) => {
        setCriteria({alertSortField, sortDirection});
    };

    return {criteria, setCriteria, setPage, setSort, reset, setPageSize};
}
